export default {
  name: '图文',
  bigImgName: '大图',
  leftImgName: '图片居左',
  rightImgName: '图片居右',
  crossedImgName: '图文左右混排',
  topImgName: '图片居上',
  label: {
    hideItemMargin: '隐藏组件间隔',
    alignTop: '顶端',
    alignCenter: '居中',
    alignBottom: '底部'
  }
}
